const DEFAULT_EMAIL_SUBJECT = "You're In! Let's Get Started 💪";

const DEFAULT_MESSAGE_BODY = `Hey {leadName}!
  \nAwesome to have you here - I've created your contract and you're just one step away from getting started.
  \nClick this link to complete your signup 👉 {onboardingLink}
  \nCan't wait to have you onboard!
  \nCheers,\n{coachName}!`;

export { DEFAULT_EMAIL_SUBJECT, DEFAULT_MESSAGE_BODY };
